import React from 'react';
import { PiLightningFill } from "react-icons/pi";

interface KeyGoalsCardProps {
  keyGoals: any[];
  onSeeAll?: () => void;
}

const KeyGoalsCard: React.FC<KeyGoalsCardProps> = ({ keyGoals, onSeeAll }) => {
  return (
    <div className="border rounded-lg p-4 bg-white shadow-sm">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-lg font-semibold">Key Goals</h2>
        <button 
          className="text-blue-600 text-sm hover:text-blue-800 transition-colors cursor-pointer"
          onClick={onSeeAll}
        >
          See All →
        </button>
      </div>
      <ul className="space-y-2 text-sm">
        {keyGoals.slice(0, 3).map((goal, index) => (
          <li key={index} className="flex items-start gap-2">
            <PiLightningFill className="mt-0.5 text-yellow-500 w-5 h-5" />
            <span>{goal.definition}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default KeyGoalsCard;